import React, { useState } from 'react';

function WeightConverter() {
  const [value, setValue] = useState('');
  const [conversionType, setConversionType] = useState('ozToG');
  const [result, setResult] = useState('');

  const conversions = [
    { id: 'ozToG', name: 'Ounces to Grams', formula: val => val * 28.3495 },
    { id: 'gToOz', name: 'Grams to Ounces', formula: val => val / 28.3495 },
    { id: 'lbToKg', name: 'Pounds to Kilograms', formula: val => val * 0.453592 },
    { id: 'kgToLb', name: 'Kilograms to Pounds', formula: val => val * 2.20462 },
    { id: 'gToCup', name: 'Grams to Cups', formula: val => val / 236.588 },
    { id: 'lbToOz', name: 'Pounds to Ounces', formula: val => val * 16 },
    { id: 'ozToLb', name: 'Ounces to Pounds', formula: val => val / 16 },
    { id: 'stToKg', name: 'Stone to Kilograms', formula: val => val * 6.35029 },
    { id: 'kgToSt', name: 'Kilograms to Stone', formula: val => val / 6.35029 }
  ];

  const handleConvert = () => {
    if (!value || isNaN(value)) {
      setResult('Please enter a valid number');
      return;
    }

    const conversion = conversions.find(c => c.id === conversionType);
    if (conversion) {
      const convertedValue = conversion.formula(parseFloat(value));
      
      // Special case for Grams to Cups which is an approximation
      if (conversionType === 'gToCup') {
        setResult(`${value} grams ≈ ${convertedValue.toFixed(2)} cups`);
      } else {
        const fromUnit = conversion.name.split(' to ')[0].toLowerCase();
        const toUnit = conversion.name.split(' to ')[1].toLowerCase();
        setResult(`${value} ${fromUnit} = ${convertedValue.toFixed(2)} ${toUnit}`);
      }
    }
  };

  return (
    <div className="converter">
      <h2>Weight Converter</h2>
      <select value={conversionType} onChange={(e) => setConversionType(e.target.value)}>
        {conversions.map(conversion => (
          <option key={conversion.id} value={conversion.id}>
            {conversion.name}
          </option>
        ))}
      </select>
      <input
        type="number"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={`Enter ${conversions.find(c => c.id === conversionType).name.split(' to ')[0]}`}
      />
      <button onClick={handleConvert}>Convert</button>
      {result && <div className="result">{result}</div>}
    </div>
  );
}

export default WeightConverter;
